export default __webpack_public_path__ + "static/media/2.10f608b7.webp";